import { createFileRoute } from "@tanstack/react-router";
import { NewProjectFlow } from "./-new/NewProjectFlow";
import type { Via } from "./-new/model";

export const Route = createFileRoute("/$workspace/new")({
  staticData: { title: "New project" },
  validateSearch: (s: Record<string, unknown>): { via?: Via } => (s.via === "github" || s.via === "ai" ? { via: s.via } : {}),
  component: NewProject,
});

function NewProject() {
  const { via } = Route.useSearch();
  return <NewProjectFlow key={via ?? "none"} initialVia={via} />;
}
